var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { propBool, propChildren, propFunc, propStr, } from '@/helpers/custom-prop-types';
/**
 * 動的にリンクの有効・無効を切り替えつつ描画するためのコンポーネント
 * @deprecated 今後はTS化されたDynamicLinkを使って下さい
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const HtmlLink = (props) => {
    const { children, isNoLinkComponent: NoLinkComponent, isObject, objectClassName, onClickNoLink, target, to } = props, otherProp = __rest(props, ["children", "isNoLinkComponent", "isObject", "objectClassName", "onClickNoLink", "target", "to"]);
    const LinkWrapper = isObject ? 'object' : Fragment;
    const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
    if (NoLinkComponent) {
        return (_jsx(NoLinkComponent, Object.assign({ onClick: onClickNoLink }, otherProp, { children: children })));
    }
    return (_jsx(LinkWrapper, Object.assign({}, (isObject ? { className: objectClassName } : {}), { children: to.indexOf('http') === 0 ? (_jsx("a", Object.assign({ href: to, rel: rel, target: target }, otherProp, { children: children }))) : (_jsx(Link, Object.assign({ rel: rel, target: target, to: to }, otherProp, { children: children }))) })));
};
HtmlLink.propTypes = {
    children: propChildren().isRequired,
    isNoLinkComponent: propStr(),
    isObject: propBool(),
    objectClassName: propStr(),
    onClickNoLink: propFunc(),
    target: propStr(),
    to: propStr().isRequired,
};
HtmlLink.defaultProps = {
    isNoLinkComponent: '',
    isObject: false,
    objectClassName: undefined,
    onClickNoLink: () => null,
    target: '',
};
export default HtmlLink;
